import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as actions from '../../redux/actions';
import { iconForField } from '../../../../common/custom/icon-library';
import history from '../../../../common/history';
import { validateSubmitBtn } from '../../ActionFormUtils';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import { getFieldInfoByName } from '../collection/Util';

class UpdateCollectionCellData extends Component {
  state = { pageContent: {}, pageId: '', roles: [] };

  createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      schema[args.name] = dbParameters ? dbParameters.value : '';
    });
    console.log('scheema', schema);
    return schema;
  };

  handleSubmit = (values) => {
    const { actionData, version, projectId, actions, selectedEvent } = this.props;
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    console.log('event data cell ', actionFormData);
    this.props.hideModal();
  };

  collectionOptions = () => {
    let options = [];
    let collections = this.props.events.collections;
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };
  collectionRequestOptions = () => {
    let options = [
      { value: 'Secured', label: 'Secured (LoggedIn User)' },
      { value: 'Open', label: 'Open (Non-LoggedIn User)' },
    ];
    return options;
  };
  // constructorOptions = (collectionName) => {
  //   let options = [];
  //   let collections = this.props.events.collections;
  //   const selectedCollection = collections.find(
  //     (collection) => collection.collectionName === collectionName,
  //   );
  //   let constructors = selectedCollection ? selectedCollection.constructors : [];
  //   if (constructors.length > 0) {
  //     options = options.concat(
  //       constructors.map((constructor) => {
  //         return { value: constructor.uuid, label: constructor.customConstructorName };
  //       }),
  //     );
  //   }
  //   return options;
  // };

  closeAllOpenPopup = () => {
    const { actions, projectId, version } = this.props;
    actions.closeActionFormModal();
    history.push(`/collections/${version}/v/${projectId}/create`);
  };

  render() {
    const { eventAction, actionData } = this.props;
    const { name } = eventAction;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createActionSettingsSchema(actionData, eventAction)}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  {/* <a
                    onClick={this.closeAllOpenPopup}
                    className="direction-custom-link btn btn-outline-info"
                    title="Create Collection"
                  >
                    <i className="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
                  </a> */}
                  <FormFieldWithLabel
                    cta={false}
                    label="Collection"
                    icon="select"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('collection')}
                  >
                    <CustomSelect
                      name={'collection'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.collectionOptions()}
                      value={values['collection']}
                      onChangeValue={this.handleChange}
                      placeholder={
                        ['updateCellData'].includes(name)
                          ? 'Select Collection'
                          : 'Select Collection (Optional)'
                      }
                    />
                    <ErrorMessage name={'collection'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>

                  <small style={{ paddingLeft: '12%' }}>
                    Select a collection in which data should be updated
                  </small>
                </div>

                <div className="form-group">
                  {name === 'updateCellData' && (
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Request Type"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter Success message (optional) you want to display on successful execution.`}
                      >
                        <CustomSelect
                          name={'collectionRequest'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={this.collectionRequestOptions()}
                          value={values['collectionRequest']}
                          placeholder={'Select Request Type (Optional)'}
                        />
                        <ErrorMessage name={'collectionRequest'}>
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </FormFieldWithLabel>
                      <small style={{ paddingLeft: '12%' }}>
                        Select the type of users to whom you allow adding new data to collection.
                      </small>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Success Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Enter Success message (optional) you want to display on successful execution.`}
                  >
                    <Field
                      type="text"
                      name="successMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="Success Message"
                    />
                    <ErrorMessage name="successMessage">
                      {(msg) => <p className="texterror">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>

                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Error Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Enter Success message (optional) you want to display on successful execution.`}
                  >
                    <Field
                      type="text"
                      name="errorMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="Error Message"
                    />
                    <ErrorMessage name="errorMessage">
                      {(msg) => <p className="texterror">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div
                      className="input-group-prepend"
                      title="Save Form Submission Data In Browser Session Form Data"
                    >
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 text-left">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={this.props.hideModal}
                >
                  <span>
                    <i className="wb webconnect-times"></i> Cancel
                  </span>
                </button>
              </div>
              <div className="col-md-6 text-right">
                <button
                  type="submit"
                  disabled={validateSubmitBtn(values, eventAction)}
                  className={`btn btn-sm ${
                    validateSubmitBtn(values, eventAction) ? 'btn-default' : 'btn-theme-submit'
                  }`}
                >
                  <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                  <CustomLoader loading={this.props.showLoaderForAction} />
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateCollectionCellData);
